import React from "react";

const TableTextualColumn = ({text}) => {
    return <td className="px-3 py-4 text-sm text-gray-500">
        {text}
    </td>
}

export default TableTextualColumn;